import OneLineSkeleton from './OneLineSkeleton';

export default OneLineSkeleton;
